import { Box, Heading, VStack } from '@chakra-ui/react';
import { Icon, IconMap } from '@common/components/Icon';
import { FontFamily } from '@common/theming/Fonts';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';

type PageHeaderProps = {
  title: string;
  subtitle: string | React.ReactNode;
  icon?: keyof typeof IconMap;
  iconColorScheme?: 'orange' | 'blue' | 'gray' | 'red' | 'green';
  step?: number;
  steps?: number;
};

export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, icon, iconColorScheme, step, steps }) => {
  const iconSize = {
    desktop: 80,
    mobile: 60,
  };
  return (
    <VStack align="center">
      {icon && (
        <Box
          w={[iconSize.mobile + 'px', iconSize.desktop + 'px']}
          h={[iconSize.mobile + 'px', iconSize.desktop + 'px']}
          position="relative"
          mb={[5, 10]}>
          <Box
            bgColor={`${iconColorScheme}.50`}
            w={[iconSize.mobile + 'px', iconSize.desktop + 'px']}
            h={[iconSize.mobile + 'px', iconSize.desktop + 'px']}
            position="absolute"
            borderRadius={[iconSize.mobile, iconSize.desktop]}></Box>
          <Box
            bgColor={['transparent', `${iconColorScheme}.100`]}
            opacity={0.5}
            w={[iconSize.mobile - 20 + 'px', iconSize.desktop - 20 + 'px']}
            h={[iconSize.mobile - 20 + 'px', iconSize.desktop - 20 + 'px']}
            position="absolute"
            borderRadius={60}
            top={[
              (iconSize.mobile - (iconSize.mobile - 20)) / 2 + 'px',
              (iconSize.desktop - (iconSize.desktop - 20)) / 2 + 'px',
            ]}
            left={[
              (iconSize.mobile - (iconSize.mobile - 20)) / 2 + 'px',
              (iconSize.desktop - (iconSize.desktop - 20)) / 2 + 'px',
            ]}></Box>
          <Icon
            icon={icon}
            boxSize={[iconSize.mobile * 0.3 + 'px', iconSize.desktop * 0.3 + 'px']}
            color={`${iconColorScheme}.300`}
            top={[
              (iconSize.mobile - iconSize.mobile * 0.3) / 2 + 'px',
              (iconSize.desktop - iconSize.desktop * 0.3) / 2 + 'px',
            ]}
            left={[
              (iconSize.mobile - iconSize.mobile * 0.3) / 2 + 'px',
              (iconSize.desktop - iconSize.desktop * 0.3) / 2 + 'px',
            ]}
            position="absolute"
          />
        </Box>
      )}
      {step && steps && (
        <TextBlock opacity="0.4" mb="10px">
          <TextBlock as="span" fontWeight="bold">{`Step ${step} `}</TextBlock>
          of {steps}
        </TextBlock>
      )}
      <Heading
        textAlign={'center'}
        fontFamily={FontFamily.HELVETICA_NOW_BOLD}
        fontWeight={'normal'}
        fontSize={'2xl'}
        mb={1.5}
        lineHeight={1.2}>
        {title}
      </Heading>
      <TextBlock textAlign={'center'} color="gray.300" fontSize={'md'} maxWidth={'640px'} weight="bold">
        {subtitle}
      </TextBlock>
    </VStack>
  );
};
